var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event event--purple" }, [
    _c("div", { staticClass: "event__wrapper" }, [
      _c("div", { staticClass: "event__text" }, [
        _c("h3", { staticClass: "event__date" }, [
          _c("span", { staticClass: "event__day" }, [_vm._v(_vm._s(_vm.day))]),
          _vm._v(" "),
          _c("span", { staticClass: "event__month" }, [
            _vm._v(_vm._s(_vm.month))
          ])
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "event__title" }, [
          _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "event__info" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.time) +
              "\n        //\n        " +
              _vm._s(_vm.location) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("figure", { staticClass: "event__image" }, [
        _c("img", { attrs: { src: _vm.image, alt: _vm.title } }),
        _vm._v(" "),
        _vm.primaryFormat
          ? _c("span", { staticClass: "event__category" }, [
              _vm._v(_vm._s(_vm.primaryFormat))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "event__link", attrs: { href: _vm.link } })
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "event__button btn btn--white btn--small",
        attrs: { href: _vm.link }
      },
      [_vm._v("Event Details")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }